export default __webpack_public_path__ + "static/media/safeguarding-support.2a45885e.png";